import { Injectable } from '@angular/core';
import { DateTime, Duration, } from 'luxon';



@Injectable({
  providedIn: 'root'
})
export class TimeService {

  constructor() { }

  daysFormat(n) {
    const time: any = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    time.days = Math.floor( n / (24 * 3600));
    n = n % (24 * 3600);
    time.hours = Math.floor( n / 3600);
    n %= 3600;
    time.minutes = Math.floor(n / 60 );
    n %= 60;
    time.seconds = Math.floor(n);
    if (time.days) {
      return time.days + ' day(s) '+ time.hours + ' hours';
    } else if (time.hours) {
      return time.hours + ' hours ' + time.minutes + ' minutes';
    } else if (time.minutes) {
      return time.minutes + ' minutes ' + time.seconds + ' seconds';
    }
  }

  IsoToUTC(value: string) {
    return DateTime.fromISO(value).toUTC();
  }

  toUTCEpoch(value: any) {
    const date: any = DateTime.fromJSDate(value).toUTC();
    return date.ts;
  }

  // is date passed today?
  isToday(d2) {
    const today: any = new Date();
    return d2.getDate() == today.getDate() &&
    d2.getMonth() == today.getMonth() &&
    d2.getFullYear() == today.getFullYear();
  }

  isDistantFuture(date, toleranceMillis = 0) {
    // number of milliseconds tolerance (i.e. 60000 == one minute)
    return date.getTime() > Date.now() + toleranceMillis
  }

  getDateFromTime(value: any, format: string) { // value should be a time string
    return DateTime.fromFormat(value, format);
  }

  toLocalDate(date, locale= 'en-IN') {
    return DateTime.local(date).setLocale(locale).toLocaleString();
  }

  toShortDate(value: string, format: string = 'dd-MMM-yyyy') {
    const date: any = DateTime.fromISO(value).toFormat(format).toLocaleString();
    return date;
  }

  toShortDateTime(value: string, format: string = 'dd-MMM-yyyy, hh:mm a') {
    const date: any = DateTime.fromISO(value).toFormat(format).toLocaleString();
    return date;
  }
  toTime(value: string, format: string = 'hh:mm a') {
    const date: any = DateTime.fromISO(value).toFormat(format).toLocaleString();
    return date;
  }
  toShortDateMonth(value: string) {
    const date: any = DateTime.fromISO(value).toLocaleString({ day: '2-digit', month: 'short'});
    return date;
  }

  toShortDateMonthTime(value: string) {
    const date: any = DateTime.fromISO(value).toLocaleString({ day: '2-digit', month: 'short', hour: 'numeric', minute: '2-digit'});
    return date;
  }

  toFromNow(value: string) {
    const date: any = DateTime.fromISO(value).toLocaleString(DateTime.DATE_SHORT);
    return date;
  }

  addToNow(value) { // adds days/hours/minutes to current dateTime
    return DateTime.local().plus({ days: value.days || 0, hours: value.hours || 0,
      minutes: value.minutes || 0});
  }

  formatDate(date, format = 'hh:mm a') {
    return DateTime.fromISO(date).toFormat(format).toLocaleString();
  }

  dateToFormat(value: DateTime, format: string) { // converts datetime object to given format
    return value.toLocal().toFormat(format);
  }

  toDayMinSec(n) {
    const time: any = {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
    time.days = Math.floor( n / (24 * 3600));
    n = n % (24 * 3600);
    time.hours = Math.floor( n / 3600);
    n %= 3600;
    time.minutes = Math.floor(n / 60 );
    n %= 60;
    time.seconds = Math.floor(n);
    if (time.days) {
      return time.days + ' days ' + time.hours + ' hours ';
    } else if (time.hours) {
      return time.hours + ' hours ' + time.minutes + ' minutes';
    } else if (time.minutes) {
      return time.minutes + ' minutes' + time.seconds + ' seconds';
    }
  }

  minutesToDaysHours(n) {
    const time: any = {
      days: 0,
      hours: 0,
      minutes: 0
    };
    time.days = Math.floor((n / 1440));
    time.hours = Math.floor((n % 1440) / 60);
    time.minutes = n % 60;
    if (time.days) {
      return time.days + ' day(s), ' + time.hours + ' hour(s), ' + time.minutes + ' minute(s)';
    } else if (time.hours) {
      return time.hours + ' hour(s), ' + time.minutes + ' minute(s)';
    } else if (time.minutes) {
      return time.minutes + ' minute(s)';
    } else {
      return time.minutes + ' minute(s)';
    }
  }

  compareDate(date1: string, date2: string, isAsc: boolean) {
    const d1 = new Date(date1);
    const d2 = new Date(date2);

    return (d1 < d2 ? -1 : 1) * (isAsc ? 1 : -1);
  }

  // find diff of two dates
  findDiff(date1: string, date2: any) {
    const d1 = DateTime.fromISO(date1);
    const d2 = DateTime.fromISO(date2);
    const result = d1.diff(d2, ['days', 'hours', 'minutes', 'seconds']);
    return result.values;
  }


  getHoursandMinutes(seconds) {
    const hours = Duration.fromObject( {second : seconds}).toFormat('hh:mm');
    return (hours.split(':')[0] + ' hrs ' + hours.split(':')[1] + ' mins');
  }

  fromJStoFormat(value: any, format: string = 'dd-MMM-yyyy, hh:mm a') {
    const date: any = DateTime.fromJSDate(value).toFormat(format).toLocaleString();
    return date;
  }

  getDurationFromNow(value) { // returns dd days hh hours mm mins
    const diff = DateTime.fromISO(value).diff(DateTime.local(), ['minutes']).toObject();
    if (diff.minutes < 0) {
      return 0;
    }
    const tempDate = Duration.fromObject({minutes: Math.floor(diff.minutes)}).toFormat('dd:hh:mm');
    let res: any = '';

    if (tempDate.split(':')[0] == '00') {
      if (tempDate.split(':')[1] == '00') {
        res = tempDate.split(':')[2] + ' mins';
      } else {
        res = tempDate.split(':')[1] + ' hrs ' + tempDate.split(':')[2] + ' mins';
      }
    } else {
      res = tempDate.split(':')[0] + ' days ' + tempDate.split(':')[1] + ' hrs ' + tempDate.split(':')[2] + ' mins';
    }
    return res;
  }
  getHoursMinutes(seconds) {
    const hours = Duration.fromObject( {second : seconds}).toFormat('hh:mm');
    return (hours.split(':')[0]+ ':' + hours.split(':')[1]);
  }
  toShortDateTime24(value: string, format: string = 'dd-MMM-yyyy HH:mm') {
    const date: any = DateTime.fromISO(value).toFormat(format).toLocaleString();
    return date;
  }
  padTo2Digits = num => num.toString().padStart(2, '0');

  convertMsToHM = (milliseconds) => {
    let seconds = Math.floor(milliseconds / 1000);
    let minutes = Math.floor(seconds / 60);
    let hours = Math.floor(minutes / 60);
    seconds %= 60;
    minutes %= 60;
    return `${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}`;
  };
  convertMinToHM = (minutes) => {
    let hours = Math.floor(minutes / 60);
    minutes %= 60;
    return `${this.padTo2Digits(hours)}:${this.padTo2Digits(minutes)}`;
  };
  
  utcToist = (utc: string, format: string = 'dd-MMM-yy') => {
    const date = DateTime.fromJSDate(new Date(utc)).setZone('Asia/Calcutta').toFormat(format);
    if (date === 'Invalid DateTime') {
      return '--';
    }
    return date;
  }
}
